import { FormInstance } from "antd";
import { Point, Route } from "tm-shared/types";

import { PageBlock } from "@/shared/pageComposition/BlockList";

import { RouteEditorFormValues } from "../components/RouteEditorForm";
import { useScheduleSelection } from "../hooks";
import { RouteEditorCapabilities } from "../RouteEditor.policy";
import { RouteEditorModalState } from "../RouteEditor.types";
import { RouteEditorEditLoaderAndMetaBlock } from "./blocks/RouteEditorEditLoaderAndMetaBlock";
import { RouteEditorEditMainContentBlock } from "./blocks/RouteEditorEditMainContentBlock";
import { RouteEditorEditModalsBlock } from "./blocks/RouteEditorEditModalsBlock";

export type RouteEditorEditModel = {
    capabilities: RouteEditorCapabilities;
    currentRoute: Route;
    initialLoading: boolean;
    schedulesLoading: boolean;
    saveLoading: boolean;
    isDeleteBlocked: boolean;
    points: Record<string, Point>;
    modalState: RouteEditorModalState;
    isRouteSwapWarningOpen: boolean;
    routeEditorForm: FormInstance<RouteEditorFormValues>;
    selection: ReturnType<typeof useScheduleSelection>;
    handlers: {
        handleSave: (force?: boolean) => Promise<void>;
        setModalState: (state: RouteEditorModalState) => void;
        setIsRouteSwapWarningOpen: (open: boolean) => void;
        refreshSchedules: () => Promise<void>;
    };
};

export const getRouteEditorEditBlocks = (
    model: RouteEditorEditModel,
): PageBlock<RouteEditorEditModel>[] => [
    {
        key: "route-editor-edit-loader-and-meta",
        order: 10,
        render: () => (
            <RouteEditorEditLoaderAndMetaBlock
                initialLoading={model.initialLoading}
                isDeleteBlocked={model.isDeleteBlocked}
                capabilities={model.capabilities}
                selection={model.selection}
                points={model.points}
                currentRoute={model.currentRoute}
                onSetModalState={model.handlers.setModalState}
            />
        ),
    },
    {
        key: "route-editor-edit-main-content",
        order: 20,
        render: () => (
            <RouteEditorEditMainContentBlock
                capabilities={model.capabilities}
                currentRoute={model.currentRoute}
                schedulesLoading={model.schedulesLoading}
                saveLoading={model.saveLoading}
                isDeleteBlocked={model.isDeleteBlocked}
                points={model.points}
                routeEditorForm={model.routeEditorForm}
                selection={model.selection}
                onSave={model.handlers.handleSave}
                onSetModalState={model.handlers.setModalState}
            />
        ),
    },
    {
        key: "route-editor-edit-modals",
        order: 30,
        render: () => (
            <RouteEditorEditModalsBlock
                modalState={model.modalState}
                isRouteSwapWarningOpen={model.isRouteSwapWarningOpen}
                onExitMultiSelectMode={model.selection.exitMultiSelectMode}
                onRefreshSchedules={model.handlers.refreshSchedules}
                onSave={model.handlers.handleSave}
                onSetModalState={model.handlers.setModalState}
                onSetIsRouteSwapWarningOpen={
                    model.handlers.setIsRouteSwapWarningOpen
                }
            />
        ),
    },
];
